module.exports = __webpack_public_path__ + "img/url.aed3f2d6.svg";